import c from "../common";

export default {
  text1: "指定商店頁面",
  text2: "指定廣告頁面",
  text3: "我的積分",
  text4: "推廣碼",
  text5: "標題 & 內容",
  text6: "圖片",
  text7: "上次推送時間",
  text8: "目標",
  text9: "全體消費者",
  text10: "位消費者",
  text11: "最近修改人",
  text12: "確定使用此範本推送通知?",
  text13: "推送",
  text14: "推送時間",
  text15: "批號",
  text16: "標題",
  text17: "詳情",
  text18: "推廣碼已不可用",
  text19: "沒有電話可接收測試通知",
  text20: "己推送通知",
  text21: "手動輸入電話格式不正確",
  text22: "發生錯誤",
  text23: "成功創建",
  text24: "更新成功",
  text25: "已刪除",
  text26: "已接收 / 目標",
  text27: "接收方式 :",
  text28: "使用App時接收通知",
  text29: "在後台點撃打開通知",
  text30: "發起人:",
  text31: "內容 (必填)",
  text32: "下載",
  text33: "選擇商店",
  text34: "搜尋商店名稱",
  text35: "選擇廣告",
  text36: "搜尋廣告名稱",
  text37: "選擇推廣碼",
  text38: "搜尋推廣碼",
  text39: "在裝置上進行測試",
  text40: "輸入電話, 即可以接收測試通知:",
  text41: "電話需要允許Pearl App 的Push Notification功能",
  text42: "請輸入長度為10位電話",
  text43: "已存在, 請從下方選擇",
  text44: "新增",
  text45: "最近使用的電話:",
  text46: "全選",
  text47: "沒有",
  text48: "通知",
  text49: "下一步",
  text50: "上載",
  text51: "選填, 只適用於Android",
  text52: "圖片網址無效",
  text53: "傳送測試訊息",
  text54: "裝置預覽",
  text55: "指定目標",
  text56: "格式: xlsx檔案要有一個名為 tel 的column, 電話範例: 1234567890, 重覆電話只算一個",
  text57: "手動輸入",
  text58: "用 , 分開每個電話, 電話範例: 1234567890",
  text59: "部份消費者",
  text60: "匯入xlsx",
  text61: "無有效電話, 請檢查xlsx格式",
  text62: "已選電話:",
  text63: "Deep Link (選填)",
  text64: "啟用",
  text65: "不可選, 沒有進行中推廣碼",
  text66: "格式不正確",
  text67: "推送通知",
  text68: "創建範本",
  text69: "範本",
  text70: "傳送記錄",
  text71: "返回",
  text72: "創建",
  text73: "儲存範本",
  text74: "確定刪除此範本? 此動作無法復原",
  text75: "刪除",
  text76: "(下載範例)",
};
